import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Notification } from '@redux-devtools/ui';
import { clearNotification } from '../actions/index.js';
import Header from '../components/Header.js';
import Actions from './Actions.js';
import Settings from '../components/Settings/index.js';
class App extends Component {
    render() {
        const { extraSettingsTabs, section, theme, notification } = this.props;
        let body;
        switch (section) {
            case 'Settings':
                body = React.createElement(Settings, { extraTabs: extraSettingsTabs });
                break;
            default:
                body = React.createElement(Actions, null);
        }
        return (React.createElement(Container, { themeData: theme },
            React.createElement(Header, { section: section }),
            body,
            notification && (React.createElement(Notification, { type: notification.type, onClose: this.props.clearNotification }, notification.message))));
    }
}
const mapStateToProps = (state) => ({
    section: state.section,
    theme: state.theme,
    notification: state.notification,
});
const actionCreators = {
    clearNotification,
};
export default connect(mapStateToProps, actionCreators)(App);
